// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_eG","menuControls_styleDefault":"c-a_eH","menuControls_styleRed":"c-a_eJ"};